export const SET_LOADING = 'SET_LOADING';

export const setLoading = (loading: boolean, actionType = 'UNSPECIFIED') => ({
  type: SET_LOADING,
  data: {
    loading,
    actionType,
  },
});
